import * as React from 'react';
import { useContext } from 'react';
import { Query } from 'react-apollo';

import { getClientName } from 'bundles/cms/utils/SpaceUtils';
import type {
  EntWebsiteNavDomainQuery,
  EntWebsiteNavDomainQueryVariables,
} from 'bundles/ent-website/__generated__/contentfulTypes';
import { EntWebsiteContext } from 'bundles/ent-website/components/EntWebsiteContext';
import { EntWebsiteDomainContext } from 'bundles/ent-website/components/EntWebsiteDomainContext';
import { entWebsiteNavDomainQuery } from 'bundles/ent-website/queries/EntWebsiteNavDomain';

type Props = {
  slug: string;
  children: React.ReactElement;
};

export type EntWebsiteNavDomainContextState = {
  data?: EntWebsiteNavDomainQuery;
  forceHideMetaNav?: boolean;
};

export const EntWebsiteNavDomainContext = React.createContext<EntWebsiteNavDomainContextState>({
  data: undefined,
} as EntWebsiteNavDomainContextState);

export const EntWebsiteNavDomainDataProvider = ({ children, slug }: Props): React.ReactElement => {
  const { isPreview, locale } = useContext(EntWebsiteContext);
  const { domain } = useContext(EntWebsiteDomainContext);

  return (
    <Query<EntWebsiteNavDomainQuery, EntWebsiteNavDomainQueryVariables>
      query={entWebsiteNavDomainQuery}
      notifyOnNetworkStatusChange={true}
      context={{ clientName: getClientName('ENTERPRISE', isPreview) }}
      errorPolicy="all"
      variables={{ domain, preview: isPreview, slug, locale }}
    >
      {({ data }) => (
        <EntWebsiteNavDomainContext.Provider
          value={{
            data,
            forceHideMetaNav: data?.entWebsitePageAssemblyCollection?.items?.[0]?.forceHideMetaNav ?? false,
          }}
        >
          {children}
        </EntWebsiteNavDomainContext.Provider>
      )}
    </Query>
  );
};

export type PropsFromWithEntWebsiteDomainContext = {
  entWebsiteDomainContext: EntWebsiteNavDomainContextState;
};
